import moment from 'moment-jalaali'

const date = (originDate, conf) => {
    const date = new Date(originDate)
    const dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    // return `${dayNames[date.getDay()]}, ${date.toLocaleString()}`
    return moment(date).format('YYYY/MM/DD')
}

export default date;